import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminSidebar, { AdminMenuButton } from "../components/AdminSidebar";
import Topbar from "../components/Topbar";

const PAGE_META = {
  "/admin": { title: "Dashboard", subtitle: "Resumen general" },
  "/admin/actividades": {
    title: "Actividades",
    subtitle: "Gestión de plantillas",
  },
  "/admin/alumnos": { title: "Alumnos", subtitle: "Lista y progreso" },
  "/admin/informes": {
    title: "Informes de respuestas",
    subtitle: "Respuestas de actividades y export a PDF",
  },
  "/admin/configuracion": {
    title: "Configuración",
    subtitle: "Ajustes del sistema",
  },
};

export default function AdminLayout() {
  const location = useLocation();
  const meta = PAGE_META[location.pathname] || PAGE_META["/admin"];
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <AdminSidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      <main className="flex-1 lg:ml-64 min-w-0">
        <Topbar
          title={meta.title}
          subtitle={meta.subtitle}
          menuButton={<AdminMenuButton onToggle={toggleSidebar} />}
        />
        <div className="p-4 md:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
